// extracted by mini-css-extract-plugin
export default {"labelBackground":"CustomInput_labelBackground__PGbnK","noPadding":"CustomInput_noPadding__I0Ekc"};